import React, { useState, useEffect } from 'react';
import Info from '../lib/info';
import Confirm from '../lib/confirm';
import Slider from '../lib/slider';
import { Pens } from '../lib/constants';
import { imgResize } from '../lib/globalData';

const Shop = props => {
  const { dataprovider, staticel, id, userinfo, is_dev } = props;
  
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categories2, setCategories2] = useState({});
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('Beliebtheit');
  const [selCat, setSelCat] = useState(false);
  const [modal, setModal] = useState(0);
  const [infoMsg, setInfoMsg] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState({});
  const [prices, setPrices] = useState(0);
  const [priceCnt, setPriceCnt] = useState({});
  const [pen, setPen] = useState(userinfo?userinfo.lastpen:'-');
  
  const CalcCat2 = (cat) => {
    setCategories(cat);
    const cat2 = {};
    for (var i = 0; i<cat.length;i++) {
      cat2[cat[i].id] = cat[i].name;
    }
    setCategories2(cat2);
  }
  
  useEffect(() => {
    dataprovider.getList('category', {sort:['pos', 'ASC']}, CalcCat2);
  }, [dataprovider]);
  
  useEffect(() => {
    setPen(userinfo.lastpen);
  }, [userinfo]);
  
  useEffect(() => {
    if (id) {
      if (id.substr(0,1)==='c') {
        setModal(0);
        setSelCat(parseInt(id.substr(1)));
      }
      else if (id.substr(0,1)==='s') {
        setModal(parseInt(id.substr(1)));
        setSelCat(0);
      }
    }
  }, [id]);
  
  useEffect(() => {
    if (id && selCat === false) return;
    dataprovider.getList('product', {filter:{id_category:selCat, q:search}, sorting:sort}, setProducts);
  }, [dataprovider, selCat, search, sort]);
  
  useEffect(() => {
    if (modal) {
      dataprovider.getList('price', {filter:{id_product:modal}}, setPrices);
    }
  }, [dataprovider, modal]);
  
  const handleCatClick = id => ev => {
    if (selCat===id) {
      setSelCat(0)
    }
    else {
      setSelCat(id)
    }
  }
  const handleProdClick = id => ev => {
    setModal(id)
    var loc = window.location.hash.split('/');
    window.location.hash = loc[0]+'/'+id;
  }
  const CloseModal = ev => {
    const cl = ev.target.className;
    if (cl.indexOf('modal fade') > -1 || cl.indexOf('btn-close') > -1) {
      setPriceCnt({});
      var loc = window.location.hash.split('/');
      window.location.hash = loc[0];
      setModal(0);
    } 
  }
  const handleSearch = ev => {
    setSearch(ev.target.value);
  }
  const handleSort = ev => {
    setSort(ev.target.value);
  }
  const handlePriceCnt = id => ev => {
    setPriceCnt({...priceCnt, [id]:parseInt(ev.target.value)});
  }
  
  const handlePenChange = ev => {
    setPen(ev.target.value);
  }
  
  const updateCartNum = (data) => {
    if (window.updateCart) {
      window.updateCart(data.cnt);
    }
  }
  const handleAddCart = ev => {
    var ok = true;
    for (var i=0;i<prices.length;i++) {
      var p = prices[i];
      if (p.type === 'demand' && priceCnt[p.id] && priceCnt[p.id]>0 && (pen==='-' || !pen)) {
        ok = false;
        alert('Bitte Stifthersteller wählen');
        break;
      }
    }
    if (ok) {
      dataprovider.insert('basket', {data: priceCnt, pen:pen}, updateCartNum);
      setPriceCnt({});
      setModal(0);
    }
  }
  const AddFree = (id) => (ev) => {
    dataprovider.insert('asset', {id_price:id});
  }
  const LoadHP = (id) => (ev) => {
    dataprovider.insert('asset/addbiblio', {id:id }, doneAddBiblio);
  }
  const addBiblio = (hp) => {
    if (hp===1) {
      if (!userinfo || !userinfo.id) {
        setInfoMsg(['Hörprojekte laden', (
          <span>
            <p>Damit du Hörprojekte kostenlos in die Bibliothek laden kannst, musst du angemeldet sein und über eine laufende Creator-Lizenz verfügen.</p>
            <p>Dazu <a href="/app#login">anmelden</a> oder <a href="/app#register">registrieren</a></p>
            <p>Anschliessend kannst du deine Hörprojekte weiter bearbeiten, Soundsticker drucken oder bestellen und den Hörstift synchronisieren.</p>
          </span>)]
        )
        setModal(0);
        return;
      }
      if (userinfo.license<1) {
        setInfoMsg(['Creator-Lizenz für Hörprojekte', (
          <span>
            <p>Damit du Hörprojekte kostenlos in die Bibliothek laden kannst, brauchst du einen laufende Creator-Lizenz. Diese findest du <a href="/app#shop/s114">hier</a></p>
            <p>Danach kannst du die Hörprojekte bearbeiten, Soundsticker drucken oder bestellen und den Hörstift synchronisieren.</p>
          </span>)]
        )
        return;
      }
      if (modprod.overwrite_hp) {
        setConfirmMsg({msg:'Hörprojekt bereits in deiner Bibliothek|Das Hörprojekt befindet sich bereits in deiner Bibliothek. Möchtest du es überschreiben?', setMsg: setConfirmMsg, 
          buttons:[{text:'Abbrechen'},{typ:'primary',text:'Überschreiben', action:LoadHP(modal)}]});  
        return;
      }
      if (modprod.channels) {
        setConfirmMsg({msg:'Sprachpakete nutzen|Dieses Hörprojekt enthält Sprachpakete. Wähle im Creator unter „Einstellungen“ die gewünschten Sprachen und Stimmen für max. sechs Kanäle. Mehr Infos unter „Tipps - Vorgefertigte Hörprojekte“', setMsg: setConfirmMsg, 
        buttons:[{text:'Abbrechen'},{typ:'primary',text:'Hörprojekt hinzufügen', action:LoadHP(modal)}]});  
        return;
      }
    }
    dataprovider.insert('asset/addbiblio', {id:modal }, doneAddBiblio);
    
  }
  const doneAddBiblio = (data) => { 
    window.document.location.href = '/app#bibliothek';
  }

  const histback = (ev) => {
    window.history.back();
  }
  
  if (categories.length < 1) return null;
  
  const cats = [];
  for(var j=0; j<products.length;j++) {
    const el = products[j]
    var cat = '';
    for(var i=0; i<el.categories.length;i++) {
      cat += (cat?' / ':'') + categories2[el.categories[i]];
    }
    cats.push(cat);
  }
  
  var modprod = false;
  if (modal > 0) {
    for (i=0;i<products.length;i++) {
      if (products[i].id===modal) {
        modprod = products[i];
        modprod.cat = cats[i];
      }
    }
  }
  
  const listanz = {demand:99,home:1,phys:99,license:99,free:1};

  const mussanmelden = prices && prices[0] && prices[0].type==='license' && (!userinfo || !userinfo.id)

  let isCount = false;
  if (prices && Array.isArray(prices)) {
    prices.forEach(p => { if (priceCnt[p.id] > 0) { isCount = true; } });
  }

  return (
    <>
      <Slider staticel={staticel} page={2} is_dev={is_dev} />
      <div className="container-fluid categoryfilter pt-5">
        <div className="mb-2"> 
          <div className="input-group float-start" style={{width:"15em"}}>
            <input className="form-control border-end-0 border" type="search" placeholder="Suche" value={search} id="example-search-input" onChange={handleSearch} />
            <span className="input-group-append">
              <button className="btn btn-outline-secondary bg-white border-start-0 border-bottom-0 border ms-n5 me-3" style={{}} type="button">
                <i className="bi bi-search"></i>
              </button>
            </span>
          </div>
          <select className="form-select me-3" value={sort} onChange={handleSort}  style={{display:"inline-block", width:"auto"}}>
            <option>Beliebtheit</option>
            <option>Titel</option>
          </select>
      { categories.map((cat, k)=>(
          <React.Fragment key={cat.id}>
            <button type="button" className={"btn btn-"+(selCat===cat.id?"primary":"secondary")+" me-2 mb-2"} onClick={handleCatClick(cat.id)} >{cat.name}</button>
          </React.Fragment>
      ))}
        </div>
      </div>
      <div className="py-3 bg-light">
        <div className="container-fluid">
          <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
      {products.map(el => {
        var cat = '';
        for(var i=0; i<el.categories.length;i++) {
          cat += (cat?' / ':'') + categories2[el.categories[i]];
        }
        return (
            <div className="col" onClick={handleProdClick(el.id)} key={el.id}>
              <div className="card">
                <div className="ratio ratio-16x9 media">
                  <div>
      {el.image && 
                    <img src={imgResize(el.image, 500)} alt="" />
      }
      {!el.image && el.video && 
                    <video onMouseOver={ ev => { ev.target.volume=0;ev.target.play()}} onMouseOut={ev => {ev.target.pause();ev.target.currentTime=0;}}>
                      <source src={el.video} type="video/mp4"></source>
                    </video>
      }
                  </div>
                </div>
                <div className="card-body px-1 py-1">
                  <h5 className="mb-0 s-small">{el.title}</h5>
                  <p className="card-text s-small">{el.claim}</p>
                </div>
              </div>
            </div>
      )})}
          </div>
        </div>
      </div>
    {modprod !== false &&
      <div className="modal fade show" style={{display:"block",backgroundColor: "rgba(0,0,0,0.5)"}} onClick={CloseModal}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header pb-2">
              <div>
                <h2>{modprod.title}</h2>
                <div>{modprod.claim}</div>
              </div>
              
              {window.history.length>1 &&<button type="button" className="btn position-relative fs-4 ms-auto" style={{top:"-0.7em"}} onClick={histback}><i className="bi bi-arrow-left"></i></button>}
              <button type="button" className="btn-close position-relative ms-2" style={{top:"-1em"}} onClick={CloseModal}></button>
            </div>
            <div className="modal-body">
        {!!modprod.video &&
              <video controls className="w-100" autoPlay>
                <source src={modprod.video} type="video/mp4"></source>
              </video>
        }
        {!modprod.video && modprod.image &&
              <img src={imgResize(modprod.image, 800)} className="w-100" alt={modprod.title} />
        }            
              <p className="mt-3" dangerouslySetInnerHTML={{ __html: window.textile(modprod.description?modprod.description:'') }} />
        {(modprod.id_project > 0 && !modprod.hoerprojekt) && 
              <button className="btn btn-secondary" onClick={() => addBiblio(0)}>Hördatei kostenlos in Bibliothek laden</button>
        }
        {modprod.hoerprojekt && 
              <button className="btn btn-primary" onClick={() => addBiblio(1)}>Hörprojekt kostenlos in Bibliothek laden</button>
            }
              <table className="table">
                <tbody>
        {prices && prices.map(p => {
                if (p.text && p.text.substring(0,1)==='!') return null;
                if (p.asset) return (
                  <tr><td colSpan="3">Produkt bereits erworben -> <a href="/app#bibliothek">Bibliothek</a></td></tr>
                )
                if (p.type==='license' && p.price===48 && userinfo.license>-1 && (userinfo.team>1 || userinfo.email!==userinfo.teamadmin)) return null;
                if (p.type==='license' && p.price===48 && userinfo.license>0) {
                  return (
                    <tr><td colSpan="3"><b>Du hast bereits eine aktive Lizenz. Zum verlängern <a href="/app#license">hier</a> klicken</b></td></tr>
                  )
                }
                if (p.type==='license' && p.price===36 && userinfo.email!==userinfo.teamadmin && userinfo.license>0) {
                  return (
                    <tr><td colSpan="3"><b>Du bist Teil eines Teams. Deine Lizenz wird von {userinfo.teamadmin} verwaltet.</b></td></tr>
                  )
                }
                return (
                  <tr key={p.id}>
          {p.type==='free'?
                    <>
                    <td colSpan="1">Soundfile zur Stift-Synchronisation in "Bibliothek" speichern (geschieht bei einem Stickerkauf automatisch</td>
                    <td colSpan="3">
            {userinfo.id?
                      <button className="btn btn-primary" onClick={AddFree(p.id)} style={{whiteSpace: 'nowrap'}}>Bibliothek hinzufügen</button>
            :
                      <span>Erst <a href="/app#login">anmelden</a> oder <a href="/app#register">registrieren</a></span>
            }
                    </td>
                    </>
          :
                    <>
                    <td>{p.text.replace(/^£/, "")}</td>
                    <td>{p.price.toFixed(2)}</td>
                    <td>
          {p.type==='demand' && 
                      <select value={pen} onChange={handlePenChange}>
          {Pens.map((pen) => {
            if (p.text && p.text.substring(0,1)==='£' && pen.value=='bookii') return false;
            return (    <option key={pen.value} value={pen.value}>{pen.text}</option>)
          }
          )}
                      </select>
          }
                    </td>  
          {!mussanmelden &&   
                    <td align="right">
                      <select value={''+priceCnt[p.id]} onChange={handlePriceCnt(p.id)}>
          {[...Array(listanz[p.type]+1)].map((x, i) => {
                if (i>1 && p.type==='license' && (p.price===48 || p.price===0)) return false;
                if (i===1 && p.type==='license' && p.price===36 && userinfo.team<1 && userinfo.license<1) return false;
                return (<option key={i} value={i}>{i}</option>)
          }
                        
          )}
                      </select>
                    </td>
          }
                    </>
          }
                  </tr>
              
        )})}
                  
        {(!mussanmelden && prices && prices.length>0) && 
                  <tr><td/><td align="right" colSpan="3" ><button className={"btn btn-"+(isCount?"primary":"secondary")}  disabled={!isCount} onClick={handleAddCart}>In den Warenkorb</button></td></tr>
        }
        {mussanmelden && 
                  <tr><td colSpan="3">Um eine Lizenz in den Warenkorb zu legen, musst du dich zuerst anmelden oder registrieren.<br/><a href="/app#login" className="btn btn-primary me-2 mt-2">anmelden</a> <a href="/app#register" className="btn btn-primary mt-2">registrieren</a></td></tr>

        }
                </tbody>
              </table> 
        {modprod.docs && !!modprod.docs.length &&
              <>
          {modprod.docs.map(dl=>(
                    <div key={dl.id}>
                      <a href={dl.url} className="btn btn-secondary me-3 mb-2" target="_blank" rel="noreferrer"><i className="bi bi-download"></i></a>
                      <a href={dl.url} target="_blank" rel="noreferrer">{dl.name}</a>
                    </div>
          ))}              
              </>  
        }
              <div  />
            </div>
          </div>
        </div>
      </div>
    }  
      <Info msg={infoMsg} setMsg={setInfoMsg} />
      <Confirm msg={confirmMsg.msg} setMsg={setConfirmMsg} buttons={confirmMsg.buttons} />
    </>
  )
}

export default Shop;
